import "core-js/modules/es.array.concat.js";
import { Colors } from '../Colors';
export var Variables = {
  primaryFontFamily: 'var(--primary-font-family, sans-serif)',
  secondFontFamily: 'var(--secondary-font-family, serif)',
  typography: {
    dizraptor: {
      titleXXL: {
        fs: 'var(--typo-dizraptor-title-xxl-fs, 3.2rem)',
        lh: 'var(--typo-dizraptor-title-xxl-lh, 1.25)'
      },
      titleXL: {
        fs: 'var(--typo-dizraptor-title-xl-fs, 2.4rem)',
        lh: 'var(--typo-dizraptor-title-xl-lh, 1.333)'
      },
      titleL: {
        fs: 'var(--typo-dizraptor-title-l-fs, 2rem)',
        lh: 'var(--typo-dizraptor-title-l-lh, 1.4)'
      },
      titleLCompact: {
        fs: 'var(--typo-dizraptor-title-compact-l-fs, 2rem)',
        lh: 'var(--typo-dizraptor-title-compact-l-lh, 1.2)'
      },
      body: {
        fs: 'var(--typo-dizraptor-body-fs, 1.6rem)',
        lh: 'var(--typo-dizraptor-body-lh, 1.375)'
      },
      footnote: {
        fs: 'var(--typo-dizraptor-footnote-fs, 1.4rem)',
        lh: 'var(--typo-dizraptor-footnote-lh, 1.428)'
      },
      note: {
        fs: 'var(--typo-dizraptor-note-fs, 1.2rem)',
        lh: 'var(--typo-dizraptor-note-lh, 1.333)'
      },
      subnote: {
        fs: 'var(--typo-dizraptor-subnote-fs, 1.1rem)',
        lh: 'var(--typo-dizraptor-subnote-lh, 1.454)'
      }
    },
    dizraptorAccent: {
      headingXL: {
        fs: 'var(--typo-dizraptor-accent-heading-xl-fs, 5.6rem)',
        lh: 'var(--typo-dizraptor-accent-heading-xl-fs, 1.071)'
      },
      heading: {
        fs: 'var(--typo-dizraptor-accent-heading-fs, 3.6rem)',
        lh: 'var(--typo-dizraptor-accent-heading-fs, 1.111)'
      },
      titleXXL: {
        fs: 'var(--typo-dizraptor-accent-title-xxl-fs, 2.8rem)',
        lh: 'var(--typo-dizraptor-accent-title-xxl-fs, 1.357)'
      },
      titleXL: {
        fs: 'var(--typo-dizraptor-accent-title-xl-fs, 2.4rem)',
        lh: 'var(--typo-dizraptor-accent-title-xl-fs, 1.333)'
      },
      titleL: {
        fs: 'var(--typo-dizraptor-accent-title-l-fs, 2rem)',
        lh: 'var(--typo-dizraptor-accent-title-l-fs, 1.4)'
      }
    }
  },
  tooltipShadow: "var(--tooltip-shadow, 0 1rem 3rem ".concat(Colors.ut.shadow10, "), 0 0 0 1px ").concat(Colors.ut.shadow10),
  tooltipRadius: 'var(--tooltip-radius, 0.8rem)',
  popupShadow: "var(--popup-shadow, 0 0.4rem 1.4rem ".concat(Colors.ut.shadow10, ", 0 1.1rem 6rem ").concat(Colors.ut.shadow10, ")"),
  popupRadius: 'var(--popup-radius, 0.8rem)',
  shimmerRadius: 'var(--shimmer-radius, 0.3rem)',
  inputRadius: 'var(--input-radius, 0.8rem)',
  hintRadius: 'var(--hint-radius, 0.8rem)',
  tagRadius: 'var(--tag-radius, 0.3rem)',
  buttonRadius: 'var(--button-radius, 0.8rem)',
  listTransitionDuration: '0.2s',
  listTransitionDurationHover: '0.1s',
  listTimingFunction: 'ease-in',
  listTimingFunctionHover: 'ease-out'
};
//# sourceMappingURL=index.js.map